// external
import { Pipe, PipeTransform, inject } from "@angular/core";

// core
import { AppConfigService } from "../services/app-config.service";

/*
 * Formats image paths relative to assets/images
 * Usage:
 *   adviceaid.png | https://aacdn.server.com/v1234/assets/images/adviceaid.png
 */
@Pipe({ name: "imageSrc" })
export class ImageSrcPipe implements PipeTransform {
  private readonly appConfig = inject(AppConfigService);

  transform(filename: string): string {
    if (!filename) {
      return "";
    }

    return this.appConfig.cdnOrigin + "/assets/images/" + filename;
  }
}
